import { api } from "./apiConfig";

export const login = async (data) => {
  try {
    
    const response = await api.post("/Users/login", data);
    
    if (response.data.token !== undefined) {
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("token", response.data.token);
      localStorage.setItem("ime", response?.data?.ime);
      localStorage.setItem("prezime", response?.data?.prezime);
      return true;
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
  return false;
};

export const logout = async () => {
  const response = await api.post("/Users/logout");
  localStorage.removeItem("isAuthenticated");
  localStorage.removeItem("token");
  return response.data;
};
